import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFileRemove$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFileRemove extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e967f3902eedc4c42b7c0fe2b9b96fd18d7b8b79', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5615c27ee30cd914c98d0a44a91bc5c177374ea1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f8142b724ed0bdd7d7fbcf32471a1a6a9a61e2a9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 3h7.91a.5.5 0 0 1 .36.15l4.08 4.07a.47.47 0 0 1 .15.35V18.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V18a.5.5 0 0 1 .5-.5h2V8h-3a.5.5 0 0 1-.5-.5v-3H6.5V8a.48.48 0 0 1-.5.48h-.5A.48.48 0 0 1 5 8V3.5a.5.5 0 0 1 .5-.5M3 15a5 5 0 1 1 10 0 5 5 0 0 1-10 0m2 .25a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-file-remove", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-file-remove"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-file-remove":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFileRemove$1);
            }
            break;
    } });
}

const CosmosIconFileRemove = CosmosIconFileRemove$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFileRemove, defineCustomElement };
